import { createContext } from 'react';
import type { FormResult } from '@frontend/utils/hooks/useForm';

export const FormContext = createContext<FormResult<any>>(null as unknown as FormResult<any>);
